import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import Home from './pages/Home';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Members from './pages/Members';
import Events from './pages/Events';
import HandoutsFamilies from './pages/Resources/HandoutsFamilies';
import HandoutsProfessionals from './pages/Resources/HandoutsProfessionals';
import Professionals from './pages/Resources/Professionals';
import SampleCourtOrders from './pages/Resources/SampleCourtOrders';

/**
 * App
 */
const App = () => (
  <Router>
    <div className="app">
      <Navbar />
      <Switch>
        <Route path="/about-us">
          <Members />
        </Route>
        <Route path="/events">
          <Events />
        </Route>
        <Route path="/resources/professional-standards-and-guidelines">
          <Professionals />
        </Route>
        <Route path="/resources/books-and-articles-by-members-of-ntxfit">
          <Redirect to="/resources/handouts-for-professionals" />
        </Route>
        <Route path="/resources/handouts-for-professionals">
          <HandoutsProfessionals />
        </Route>
        <Route path="/resources/resources-for-families">
          <HandoutsFamilies />
        </Route>
        <Route path="/resources/sample-court-orders">
          <SampleCourtOrders />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
      <Footer />
    </div>
  </Router>
);

export default App;
